// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeEdu = {
  eduPlatformApplicationNotFound: "EDU プラットフォームアプリケーション {app_key} が見つかりません",
  eduPlatformDataContractInvalid:
    "EDU プラットフォームデータ契約が無効です ({field_name}: {reason})",
} as const;
